import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const OrderSummary = ({ 
  subtotal, 
  discount, 
  total, 
  promoCode, 
  onPromoCodeChange, 
  onApplyPromo, 
  promoError,
  onCheckout,
  itemCount 
}) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8 space-y-4 md:space-y-6 sticky top-20">
      <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
        Order Summary
      </h2>
      <div className="space-y-3 md:space-y-4">
        <div className="flex justify-between items-center text-sm md:text-base">
          <span className="text-muted-foreground">
            Subtotal ({itemCount} {itemCount === 1 ? 'item' : 'items'})
          </span>
          <span className="font-medium text-foreground data-text">
            ${subtotal?.toFixed(2)}
          </span>
        </div>

        {discount > 0 && (
          <div className="flex justify-between items-center text-sm md:text-base">
            <span className="text-success">Discount</span>
            <span className="font-medium text-success data-text">
              -${discount?.toFixed(2)}
            </span>
          </div>
        )}

        <div className="pt-3 md:pt-4 border-t border-border">
          <div className="flex justify-between items-center">
            <span className="text-base md:text-lg font-medium text-foreground">
              Total
            </span>
            <span className="text-2xl md:text-3xl font-heading font-semibold text-foreground data-text">
              ${total?.toFixed(2)}
            </span>
          </div>
          <p className="text-xs md:text-sm text-muted-foreground mt-2">
            Tax included where applicable
          </p>
        </div>
      </div>
      <div className="space-y-3">
        <div className="flex gap-2">
          <Input
            type="text"
            placeholder="Promo code"
            value={promoCode}
            onChange={(e) => onPromoCodeChange(e?.target?.value)}
            error={promoError}
            className="flex-1"
          />
          <Button
            variant="outline"
            onClick={onApplyPromo}
            className="flex-shrink-0"
          >
            Apply
          </Button>
        </div>
      </div>
      <Button
        variant="default"
        size="lg"
        fullWidth
        iconName="ShoppingCart"
        iconPosition="left"
        onClick={onCheckout}
      >
        Proceed to Checkout
      </Button>
      <div className="space-y-3 pt-4 border-t border-border">
        <div className="flex items-start gap-3 text-sm text-muted-foreground">
          <Icon name="Shield" size={18} className="flex-shrink-0 mt-0.5 text-success" />
          <span>Secure SSL encrypted payment processing</span>
        </div>
        <div className="flex items-start gap-3 text-sm text-muted-foreground">
          <Icon name="Download" size={18} className="flex-shrink-0 mt-0.5 text-success" />
          <span>Instant download access after purchase</span>
        </div>
        <div className="flex items-start gap-3 text-sm text-muted-foreground">
          <Icon name="RefreshCw" size={18} className="flex-shrink-0 mt-0.5 text-success" />
          <span>30-day money-back guarantee</span>
        </div>
      </div>
      <div className="flex items-center justify-center gap-3 pt-4 border-t border-border">
        <Icon name="Lock" size={20} className="text-muted-foreground" />
        <Icon name="CreditCard" size={20} className="text-muted-foreground" />
        <Icon name="Smartphone" size={20} className="text-muted-foreground" />
        <span className="text-xs text-muted-foreground">Secure Payment</span>
      </div>
    </div>
  );
};

export default OrderSummary;